import * as React from "react"
import Svg, { Rect, G, Path, Defs } from "react-native-svg"
/* SVGR has dropped some elements not supported by react-native-svg: filter */

function CreditLimit(props) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={52}
            height={52}
            viewBox="0 0 52 52"
            fill="none"
            {...props}
        >
            <Rect width={52} height={52} rx={6} fill="#F3F5FC" />
            <G>
                <Path
                    d="M31.137 7.744a2.174 2.174 0 012.834 1.19l5.34 13.074a2.174 2.174 0 01-1.19 2.835l-22.217 9.075a2.174 2.174 0 01-2.835-1.19L7.73 19.653a2.174 2.174 0 011.19-2.835l22.218-9.075z"
                    fill="#fff"
                    stroke="#BFC5D0"
                    strokeWidth={0.42}
                />
                <Path
                    d="M8.859 21.863l25.853-10.56 1.283 3.141-25.853 10.56-1.283-3.14z"
                    fill="#DFE2E8"
                />
                <Path
                    d="M31.69 22.058l.792 1.938c.061.15.232.221.382.16l3.081-1.259a.293.293 0 00.16-.382l-.79-1.937a.293.293 0 00-.383-.16l-3.08 1.258a.293.293 0 00-.161.382z"
                    fill="#D0D6F5"
                />
                <Path
                    d="M16.43 25.317l-3.246 1.326a.533.533 0 01-.403-.987l3.246-1.326a.533.533 0 11.404.987zM19.46 26.162l-5.084 2.077c-.427.175-.863.095-.975-.178-.111-.272.145-.634.572-.809l5.085-2.077c.427-.174.863-.095.974.178.111.272-.144.635-.571.81z"
                    fill="#1434CB"
                />
            </G>
            <G>
                <Path
                    d="M39.416 21.446a2.174 2.174 0 012.118 2.228l-.357 14.117a2.174 2.174 0 01-2.228 2.119l-23.991-.607a2.174 2.174 0 01-2.119-2.228l.357-14.118a2.174 2.174 0 012.229-2.118l23.991.607z"
                    fill="#fff"
                    stroke="#BFC5D0"
                    strokeWidth={0.42}
                />
                <Path
                    d="M13.344 25.434l27.918.706-.086 3.392-27.918-.706.086-3.392z"
                    fill="#DFE2E8"
                />
                <Path
                    d="M34.177 34.778l-.053 2.092a.293.293 0 00.286.3l3.327.085a.293.293 0 00.3-.286l.053-2.092a.293.293 0 00-.285-.3l-3.328-.084a.293.293 0 00-.3.285z"
                    fill="#D0D6F5"
                />
                <Path
                    d="M18.892 31.637l-3.506-.088a.533.533 0 11.027-1.066l3.506.088a.533.533 0 11-.027 1.066zM21.328 33.627l-5.49-.138c-.462-.012-.83-.26-.822-.555.008-.294.387-.523.849-.511l5.49.138c.462.012.83.26.822.554-.008.295-.387.524-.849.512z"
                    fill="#1434CB"
                />
            </G>
            <Defs></Defs>
        </Svg>
    )
}

export default CreditLimit
